import React from 'react';
import { Spinner, Pane, Heading } from 'evergreen-ui';

const AuthLoadingScreen = () => {
  return (
    <Pane
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      backgroundColor="#f7fafc"
    >
      <Spinner size={48} />
      <Heading size={600} marginTop={16} color="#718096">
        Verificando autenticação...
      </Heading>
    </Pane>
  );
};

export default AuthLoadingScreen;
